<div class="tooth-div" @tooltip [innerHTML]="text"></div>